import axios from '../../../build/http-requests/axios-common'

const emptyTask = {
  id: null,
  nome: '',
  tipoVinculo: '',
  descricao: '',
  situacao: null,
  dataVencimento: null,
  dataAlteracao: null,
  responsavel: null,
  conclusaoAutomatica: [],
  enviarEmail: false,
  historico: null
}

export default {
  state: {
    task: Object.assign({}, emptyTask),
    hadTasksBonded: false,
    isLoadingTaskData: false,
    isManagingTask: false,
    hasActiveTask: false
  },

  mutations: {
    SET_EMPTY_TASK (state) {
      state.task = Object.assign({}, emptyTask)
    },

    SET_TASK (state, task) {
      Object.assign(state.task, task)
    },

    SET_HAD_TASKS_BONDED (state, hadTasksBonded) {
      state.hadTasksBonded = hadTasksBonded
    },

    SET_IS_LOADING_TASK_DATA (state, isLoadingTaskData) {
      state.isLoadingTaskData = isLoadingTaskData
    },

    SET_IS_MANAGING_TASK (state, isManagingTask) {
      state.isManagingTask = isManagingTask
    },

    SET_HAS_ACTIVE_TASK (state, hasActiveTask) {
      state.hasActiveTask = hasActiveTask
    },

    CLEAR_FLAGS_TASKS (state) {
      state.hadTasksBonded = false
      state.isLoadingTaskData = false
      state.isManagingTask = false
      state.hasActiveTask = false
    }
  },

  actions: {
    createMassTask: ({ commit }, massTaskData) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/createMassTask', massTaskData).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    createNewTask: ({ commit }, newTaskData) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/createNewTask', newTaskData).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    loadTasksFromStatement: ({ commit }, statmentData) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/loadTasksFromStatement', statmentData).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    loadOpenTasksFromStatementIds: ({ commit }, statementIds) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/loadOpenTasksFromStatementIds', statementIds).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    saveTaskOcurrence: ({ commit }, taskOcur) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/saveTaskOcurrence', taskOcur).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getTaskDetails: ({ commit }, taskId) => {
      return new Promise((resolve, reject) => {
        axios.get('/tasks/getTaskDetails/' + taskId).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    reopenTask: ({ commit }, taskOcur) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/reopenTask', taskOcur).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    assignTaskToLoggedUser: ({ commit }, task) => {
      return new Promise((resolve, reject) => {
        axios.post('/tasks/assignTaskToLoggedUser', task).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setEmptyTask: ({commit}) => {
      commit('SET_EMPTY_TASK')
    },

    setTask: ({commit}, newTask) => {
      commit('SET_TASK', newTask)
    },

    setTaskConfiguration: ({ commit }, { isLoadingTask, hasBondedTask, managingTask }) => {
      commit('SET_IS_LOADING_TASK_DATA', isLoadingTask)
      commit('SET_HAD_TASKS_BONDED', hasBondedTask)
      commit('SET_IS_MANAGING_TASK', managingTask)
    },

    setIsManagingTask: ({commit}, isManagingTask) => {
      commit('SET_IS_MANAGING_TASK', isManagingTask)
    },

    setHasActiveTask: ({commit}, hasActiveTask) => {
      commit('SET_HAS_ACTIVE_TASK', hasActiveTask)
    },

    clearFlagsTasks: ({commit}) => {
      commit('CLEAR_FLAGS_TASKS')
    }
  },

  getters: {
    task: state => state.task,
    hadTasksBonded: state => state.hadTasksBonded,
    isLoadingTaskData: state => state.isLoadingTaskData,
    isManagingTask: state => state.isManagingTask,
    hasActiveTask: state => state.hasActiveTask
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/task.js